import styled from 'styled-components';

const TitleSubscriber = styled.div`
	h2 {
		font-size: ${({ theme }) => theme.fontSizeTitleSubscriber};
		color: ${({ theme }) => theme.colorTitleSubscriber};
		font-family: ${({ theme }) => theme.fontFamilyTitleSubscriber};
		font-weight: ${({ theme }) => theme.fontWeightTitleSubscriber};
		margin: 0 0 30px 0;
	}

	h4 {
		color: ${({ theme }) => theme.colorTitleSubscriber};
		font-family: ${({ theme }) => theme.fontFamilyTitleSubscriber};
		font-weight: ${({ theme }) => theme.fontWeightTitleSubscriber};
		margin: 15px 0 25px 0;
	}

	.f-bold {
		color: ${({ theme }) => theme.colorTitleSubscriber};
		font-family: ${({ theme }) => theme.fontFamilyStrongTitleSubscriber};
		font-weight: ${({ theme }) => theme.fontWeightStrongTitleSubscriber};
	}

	@media screen and (min-width: 992px) {
		h2 {
			font-size: ${({ theme }) => theme.fontSizeTitleSubscriber};
			margin: 0 0 30px 0;
		}
	}
`;

export default TitleSubscriber;
